module.exports = __webpack_public_path__ + "static/img/anna_qrcode.210ceb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/anna_qrcode.jpg
// module id = L4zK
// module chunks = 1